import React from "react";
import { Typography, Box } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { useEffect } from "react";
import { fetchDashboardStatistics } from "../IndividualSearchPage/individualSearchSlice";
import { updateAuthorized } from "../../../DataExtractionTool/Authentication/authenticationSlice";

const DashboardPage = () => {
  const { user, isAuthorised } = useSelector((state) => state.authentication);
  const { statistics, statisticsStatus, isSessionValid } = useSelector(
    (state) => state.individualSearch
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isAuthorised) {
      navigate("/");
    } else {
      dispatch(fetchDashboardStatistics());
    }
  }, [dispatch, isAuthorised]);

    if (!isSessionValid) {
      dispatch(updateAuthorized(false));
    }

  return (
    <>
      <Box sx={{ padding: 4 }}>
        <Typography
          variant="h4"
          sx={{
            fontFamily: "Montserrat, sans-serif",
            fontWeight: "bold",
            textAlign: "center",
            marginBottom: 4,
            color: "#2E3B55",
          }}
        >
          Key Statistics
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-around",
            alignItems: "center",
            flexWrap: "wrap",
            border: "1px solid #ddd",
            padding: 6,
            borderRadius: 3,
            backgroundColor: "#f9f9f9",
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
          }}
        >
          {statisticsStatus === "loading" ? (
            <Typography>Loading statistics...</Typography>
          ) : statistics && typeof statistics === "object" ? (
            Object.entries({
              totalRecords: { label: "Total Records", color: "#4CAF50" },
              ahpraValidated: { label: "AHPRA Validated", color: "#2196F3" },
              registrationExpired: {
                label: "Registration Expired",
                color: "#FF5722",
              },
              awaitingApproval: {
                label: "Awaiting Approval",
                color: "#FFC107",
              },
              ytdMatchCount: { label: "YTD Match Count", color: "#673AB7" },
            }).map(([key, { label, color }]) => (
              <Box
                key={key}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  marginBottom: { xs: 4, md: 0 },
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: "bold",
                    fontFamily: "Montserrat, sans-serif",
                    marginBottom: 2,
                    color: "#2E3B55",
                  }}
                >
                  {label}
                </Typography>
                <Typography
                  variant="h5"
                  sx={{ fontWeight: "bold", color: color }}
                >
                  {statistics[key] || "-"}
                </Typography>
              </Box>
            ))
          ) : (
            <Typography>Error loading statistics</Typography>
          )}
        </Box>
      </Box>
    </>
  );
};

export default DashboardPage;
